/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetAuthorizedAccountsRequest} from '@cash-web/protos/squareup/cash/janus/api/JanusService.pb'
import {GetAuthorizedAccountsResponse} from '@cash-web/protos/squareup/cash/janus/api/JanusService.pb'


export const getAuthorizedAccounts = (request: GetAuthorizedAccountsRequest, options?: CashRequestOptions) => post<GetAuthorizedAccountsRequest, GetAuthorizedAccountsResponse>("/2.0/cash/get-authorized-accounts", request, {...options, rejectOnError: true })